import React, { useEffect, useState } from 'react';
import IndexShell from './ForBusiness/Dashboard/IndexShell';
import { Btn, NoticeState, PageHeader } from './ForBrands/ui/BrandUI';
import PartnerApiDocs from './common/PartnerApiDocs';
import { API_BASE_URL } from '../constants';

// Public API documentation (/p/api-docs): the exact docs from the admin API
// Keys page (shared PartnerApiDocs component), reachable without a login so
// API consumers can integrate against it. It sits in the same V2 frame as
// the public Player Index (IndexShell imports nothing from the store). Keys
// themselves are still issued by the Cache team through the admin console.
const PublicTopbarActions = () => (
  <>
    <span className="hidden bm-overline sm:inline">Partner API</span>
    <span className="hidden h-5 w-px bg-bm-border sm:inline" />
    <Btn variant="secondary" to="/login">Log in</Btn>
  </>
);

// The plans, prices and credit packages (users/api_plans.py, served at
// public/api-plans/). A failed call leaves the plans section at its intro.
const usePartnerPlans = () => {
  const [plans, setPlans] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE_URL}/public/api-plans/`)
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null)
      .then((d) => { if (!cancelled && d && Array.isArray(d.plans)) setPlans(d); });
    return () => { cancelled = true; };
  }, []);
  return plans;
};

// A partner lands here from a payment link (?payment=success or
// ?payment=cancelled); the plan or credits arrive moments later.
const PAYMENT_NOTICES = {
  success: "Payment received. Your key's plan or credits are active within a minute.",
  cancelled: 'Payment cancelled. Nothing was charged.',
};

// Own keys only, so a crafted ?payment=__proto__ never reaches the page.
const paymentNotice = () => {
  try {
    const payment = new URLSearchParams(window.location.search).get('payment');
    return Object.prototype.hasOwnProperty.call(PAYMENT_NOTICES, payment) ? PAYMENT_NOTICES[payment] : '';
  } catch (e) {
    return '';
  }
};

const PublicApiDocsPage = () => {
  const plans = usePartnerPlans();
  const notice = paymentNotice();
  return (
    <IndexShell homeTo="/p/business/dashboard" right={<PublicTopbarActions />}>
      <PageHeader
        eyebrow="Partner API"
        title="API documentation"
        subtitle="Read-only REST access to Cache athlete data for approved partner platforms."
      />
      {notice && <NoticeState role="status" className="mb-6">{notice}</NoticeState>}
      <PartnerApiDocs plans={plans} />
      <p className="mt-10 border-t border-bm-border pt-6 bm-body-m text-bm-muted">
        Need an API key? Contact the Cache team. Keys are issued per partner
        with their own rate limits and allowed origins.
      </p>
    </IndexShell>
  );
};

export default PublicApiDocsPage;
